const TyniAMC = {
  TyniAMCAPIKEy: `55zn95sfjfwl23gwrd9ww4etc34562q1n58l5lvvgcgpbkot`,
  /////// /http://www.resgroup.mypreview.xyz/ //////
};

export default TyniAMC;
